// Public-listing visibility rules for teacher accounts.
//
// Real students must never see internal QA/test accounts. A teacher is hidden
// from public listings when it is explicitly flagged (isTestAccount / hidden /
// status), when its email is on a known QA/test domain, OR when its display
// name exactly matches one of the known seeded test accounts. The name list is
// an EXACT, lower-cased match on purpose — a fuzzy "contains test/qa" rule
// would wrongly hide real users (e.g. someone named "Qasim" or with the
// surname "Tester"). New test accounts should set `isTestAccount: true` or use
// one of the hidden email domains rather than rely on their name.
const TEST_TEACHER_NAMES = new Set([
  "qa teacher",
  "test teacher",
  "quinn testteacher",
]);

// Any account with an email on one of these domains is a QA/seed/test
// account, never a real teacher — matched as an exact domain suffix (not a
// substring), so "notexample.com" or "example.com.evil.com" are unaffected.
const HIDDEN_EMAIL_DOMAINS = new Set(["example.com", "crescendo-qa.com"]);

const hasHiddenEmailDomain = (email) => {
  const domain = `${email || ""}`.trim().toLowerCase().split("@")[1];
  return domain ? HIDDEN_EMAIL_DOMAINS.has(domain) : false;
};

export const isPublicTeacher = (teacher) => {
  if (!teacher) return false;
  if (teacher.isTestAccount === true || teacher.hidden === true) return false;
  if (teacher.status === "hidden" || teacher.status === "flagged") return false;
  if (hasHiddenEmailDomain(teacher.email)) return false;

  const name = `${teacher.displayName || teacher.name || ""}`
    .trim()
    .toLowerCase();
  if (TEST_TEACHER_NAMES.has(name)) return false;

  return true;
};

// Filter a list of teachers down to the ones a real user may see.
export const filterPublicTeachers = (teachers = []) =>
  Array.isArray(teachers) ? teachers.filter(isPublicTeacher) : [];
